/**
 * Escapa texto que vai para `innerHTML`.
 *
 * O widget monta HTML por concatenação, e boa parte do que ele mostra vem de fora: o bloco
 * `reporter` da página host, o comentário de uma anotação (POST anônimo, sem validação por
 * elemento no intake) e a resposta do time. Nada disso passa por um framework que escape
 * sozinho — aqui não há React.
 *
 * Vive em módulo próprio porque agora tem dois consumidores (`widget.ts` e `campoEmail.ts`), e
 * a última coisa que se quer duplicar é uma função de escape: a cópia esquecida é o furo.
 */
export function escapar(s: string): string {
  return s.replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" })[c] ?? c);
}
